exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  font-size: 14pt;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/agb/agb.component.less
// module id = ../../../../../src/app/content/agb/agb.component.less
// module chunks = 1